<template>
  <div>
    <div class="bjtit ft24">联系方式</div>
    <div class="leibt clearfix">
      <a href="javascript:;" title class="cur">{{list[0].title}}</a>
    </div>
    <div class="bjlbsi">
      <div class="consc" style="display: block;">
        <div class="bjimgs">
          <img :src="list[0].imageUrl" style="width: 920px; height: 549px;" />
        </div>
        <ul class="addList">
          <li class="animation clearfix" v-for="item in list.slice(1)" :key="item.id">
            <div class="t ft24">{{item.listTitle}}</div>
            <div v-html="item.content"></div>
            <a class="clickMap" :href="item.linkUrl" target="_blank">查看地图</a>
          </li>
        </ul>
      </div>
      <br />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Array
  },
  data() {
    return {
      list: this.$props.data
    };
  }
};
</script>